import { PrimaryButton, TertiaryButton } from './Buttons/Button'
import OutsideAlerter from '../../utils/OutsideAlerter'
import { ChromePicker } from 'react-color'
import { useEffect, useState } from 'react'
import { trans } from '../../utils/utilsTrans'

function ColorSquare({ color, isSelected, onClick, smaller }) {
  return (
    <div
      className={
        'flex justify-center items-center border border-primaryLight7 block p-8 rounded-8 cursor-pointer transition-transform duration-200 hover:scale-105 w-32 h-32'
      }
      data-cy={'color'}
      style={{ backgroundColor: color }}
      onClick={() => (onClick ? onClick() : null)}
    >
      {isSelected ? (
        <i className='icon-check text-white text-xl leading-[20px]' />
      ) : null}
    </div>
  )
}

const ModalColorPicker = ({
  value,
  closeModal,
  onChange,
  position,
  propositions,
}) => {
  const [color, setColor] = useState(value)
  const [modalPicker, displayPicker] = useState(null)
  const [initialScroll, setInitialScroll] = useState(window.scrollY)
  const [variationPos, setVariationPos] = useState(0)

  const updatePositionY = () => {
    setVariationPos(initialScroll - window.scrollY)
  }

  useEffect(() => {
    document.addEventListener('scroll', updatePositionY)
    return () => {
      document.removeEventListener('scroll', updatePositionY)
    }
  })

  return (
    <OutsideAlerter onClickOutside={closeModal}>
      <div
        className='z-50 fixed top-0 left-0 mt-8 p-16 bg-white shadow-lg rounded-8 border border-greyLight8'
        style={{
          transform: `translate(${position?.left + 55}px, ${
            position?.top - 72 + variationPos
          }px)`,
        }}
      >
        {propositions?.length ? (
          <div className='mb-16'>
            <h3 className='block mb-8 font-semibold text-greyLight1 text-sm'>
              {trans('graphic_chart.logo.colors')}
            </h3>
            <div className='flex space-x-8'>
              {propositions.map((v) => (
                <ColorSquare
                  key={'color_' + v.hex}
                  color={v.hex}
                  isSelected={color === v.hex}
                  onClick={() => setColor(v.hex)}
                />
              ))}
            </div>
          </div>
        ) : null}
        <h3 className='block mb-8 font-semibold text-greyLight1 text-sm'>
          {trans('modals.colors.predefined')}
        </h3>
        <div className='flex space-x-8'>
          <ColorSquare
            color='#F95E61'
            isSelected={color === '#F95E61'}
            onClick={() => setColor('#F95E61')}
          />
          <ColorSquare
            color='#F08C43'
            isSelected={color === '#F08C43'}
            onClick={() => setColor('#F08C43')}
          />
          <ColorSquare
            color='#FBC321'
            isSelected={color === '#FBC321'}
            onClick={() => setColor('#FBC321')}
          />
          <ColorSquare
            color='#4FC092'
            isSelected={color === '#4FC092'}
            onClick={() => setColor('#4FC092')}
          />
          <ColorSquare
            color='#5EA2F8'
            isSelected={color === '#5EA2F8'}
            onClick={() => setColor('#5EA2F8')}
          />
          <ColorSquare
            color='#8F78F7'
            isSelected={color === '#8F78F7'}
            onClick={() => setColor('#8F78F7')}
          />
          <ColorSquare
            color='#EE5EA3'
            isSelected={color === '#EE5EA3'}
            onClick={() => setColor('#EE5EA3')}
          />
        </div>
        <h3 className='block mb-8 font-semibold text-greyLight1 mt-16 text-sm'>
          {trans('modals.colors.personalized')}
        </h3>
        <div className='flex p-8 border border-greyLight7 bg-backgroundPrimary rounded-8 space-x-8'>
          <ColorSquare
            color={color}
            smaller
            onClick={() => displayPicker(!modalPicker)}
          />
          <input
            onChange={(e) => setColor(e.target.value)}
            value={color}
            placeholder='#000000'
            className='bg-backgroundPrimary flex-grow outline-none'
          />
        </div>
        <div className='flex justify-end space-x-16 mt-24'>
          <TertiaryButton
            text={trans('cancel')}
            onClick={closeModal}
            cypress='cancel-color'
          />
          <PrimaryButton
            text={trans('validate')}
            cypress='edit-color'
            onClick={() => {
              onChange(color)
            }}
          />
        </div>
        {modalPicker ? (
          <OutsideAlerter
            onClickOutside={() => displayPicker(false)}
            className='select-none'
          >
            <ChromePicker
              color={color}
              className='absolute right-[100%] mr-8 bottom-0 rounded-8'
              disableAlpha
              onChange={(data) => {
                setColor(data.hex)
                // displayPicker(false)
              }}
            />
          </OutsideAlerter>
        ) : null}
      </div>
    </OutsideAlerter>
  )
}

export default ModalColorPicker
